export default "__VITE_ASSET__7fa8379b__"